import { buildSlice, CommonState } from '~libs/reduxUtils';

import { SahBudget } from '~support-at-home/models';

import { getAll, getOne, typePrefix, uploadFile } from '~support-at-home/actions/sahBudgets';

interface State extends CommonState<SahBudget> {
  clientRows: SahBudget[];
}

const initialState: State = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  uploadError: null,
  rows: [],
  clientRows: [],
};

const slice = buildSlice<State, SahBudget>(typePrefix, initialState, {
  extraReducers(builder) {
    builder.addCase(getOne.fulfilled, (state, action) => {
      state.loading = 'fulfilled';
      state.clientRows = action.payload.data;
    });
    builder.addCase(uploadFile.rejected, (state, action) => {
      state.uploadError = action.payload as string;
    });
  },
  customActions: {
    clearError(state) {
      state.uploadError = null;
      state.error = null;
    },
  },
  commonConfig: { getAll },
});

export const { clear, clearError } = slice.actions;
export default slice.reducer;
